@file:OptIn(InternalResourceApi::class)

package top.features.venues.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.features.venues.generated.resources/"

@delegate:ResourceContentHash(-629_656_103)
internal val Res.string.venue_category_production_photo_video: StringResource by lazy {
      StringResource("string:venue_category_production_photo_video", "venue_category_production_photo_video", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8061, 101),
      ))
    }

@delegate:ResourceContentHash(-2_031_188_565)
internal val Res.string.venue_category_psychotherapy: StringResource by lazy {
      StringResource("string:venue_category_psychotherapy", "venue_category_psychotherapy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8163, 104),
      ))
    }

@delegate:ResourceContentHash(-1_130_343_384)
internal val Res.string.venue_category_quest_vr: StringResource by lazy {
      StringResource("string:venue_category_quest_vr", "venue_category_quest_vr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8268, 71),
      ))
    }

@delegate:ResourceContentHash(-1_711_503_413)
internal val Res.string.venue_category_real_estate_agency: StringResource by lazy {
      StringResource("string:venue_category_real_estate_agency", "venue_category_real_estate_agency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8340, 121),
      ))
    }

@delegate:ResourceContentHash(205_467_232)
internal val Res.string.venue_category_renovation_design: StringResource by lazy {
      StringResource("string:venue_category_renovation_design", "venue_category_renovation_design", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8462, 120),
      ))
    }

@delegate:ResourceContentHash(1_868_206_177)
internal val Res.string.venue_category_restaurant: StringResource by lazy {
      StringResource("string:venue_category_restaurant", "venue_category_restaurant", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8583, 57),
      ))
    }

@delegate:ResourceContentHash(1_092_048_988)
internal val Res.string.venue_category_search_placeholder: StringResource by lazy {
      StringResource("string:venue_category_search_placeholder", "venue_category_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8641, 97),
      ))
    }

@delegate:ResourceContentHash(1_569_309_310)
internal val Res.string.venue_category_shoe_clothes_repair: StringResource by lazy {
      StringResource("string:venue_category_shoe_clothes_repair", "venue_category_shoe_clothes_repair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8739, 110),
      ))
    }

@delegate:ResourceContentHash(2_112_165_693)
internal val Res.string.venue_category_solarium: StringResource by lazy {
      StringResource("string:venue_category_solarium", "venue_category_solarium", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8850, 51),
      ))
    }

@delegate:ResourceContentHash(820_571_399)
internal val Res.string.venue_category_spa_massage: StringResource by lazy {
      StringResource("string:venue_category_spa_massage", "venue_category_spa_massage", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8902, 62),
      ))
    }

@delegate:ResourceContentHash(187_741_959)
internal val Res.string.venue_category_steak_house: StringResource by lazy {
      StringResource("string:venue_category_steak_house", "venue_category_steak_house", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8965, 82),
      ))
    }

@delegate:ResourceContentHash(901_614_383)
internal val Res.string.venue_category_sushi_asian: StringResource by lazy {
      StringResource("string:venue_category_sushi_asian", "venue_category_sushi_asian", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9048, 90),
      ))
    }

@delegate:ResourceContentHash(-472_761_198)
internal val Res.string.venue_category_tattoo_piercing: StringResource by lazy {
      StringResource("string:venue_category_tattoo_piercing", "venue_category_tattoo_piercing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9139, 74),
      ))
    }

@delegate:ResourceContentHash(-681_021_932)
internal val Res.string.venue_category_tax_consulting: StringResource by lazy {
      StringResource("string:venue_category_tax_consulting", "venue_category_tax_consulting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9214, 109),
      ))
    }

@delegate:ResourceContentHash(-1_678_876_085)
internal val Res.string.venue_category_taxi_rental: StringResource by lazy {
      StringResource("string:venue_category_taxi_rental", "venue_category_taxi_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9324, 82),
      ))
    }

@delegate:ResourceContentHash(-1_274_413_079)
internal val Res.string.venue_category_tech_repair: StringResource by lazy {
      StringResource("string:venue_category_tech_repair", "venue_category_tech_repair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9407, 98),
      ))
    }

@delegate:ResourceContentHash(602_261_251)
internal val Res.string.venue_category_tire_service: StringResource by lazy {
      StringResource("string:venue_category_tire_service", "venue_category_tire_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9506, 63),
      ))
    }

@delegate:ResourceContentHash(-241_183_431)
internal val Res.string.venue_category_tourism_hotels: StringResource by lazy {
      StringResource("string:venue_category_tourism_hotels", "venue_category_tourism_hotels", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9570, 101),
      ))
    }

@delegate:ResourceContentHash(395_301_405)
internal val Res.string.venue_category_training_center: StringResource by lazy {
      StringResource("string:venue_category_training_center", "venue_category_training_center", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9672, 82),
      ))
    }

@delegate:ResourceContentHash(-1_134_644_411)
internal val Res.string.venue_category_transfer_taxi: StringResource by lazy {
      StringResource("string:venue_category_transfer_taxi", "venue_category_transfer_taxi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9755, 80),
      ))
    }

@delegate:ResourceContentHash(-135_483_760)
internal val Res.string.venue_category_travel_agency: StringResource by lazy {
      StringResource("string:venue_category_travel_agency", "venue_category_travel_agency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9836, 88),
      ))
    }

@delegate:ResourceContentHash(986_286_497)
internal val Res.string.venue_category_tuning_detailing: StringResource by lazy {
      StringResource("string:venue_category_tuning_detailing", "venue_category_tuning_detailing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9925, 83),
      ))
    }

@delegate:ResourceContentHash(-577_422_576)
internal val Res.string.venue_category_tutoring: StringResource by lazy {
      StringResource("string:venue_category_tutoring", "venue_category_tutoring", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10009, 59),
      ))
    }

@delegate:ResourceContentHash(1_695_166_720)
internal val Res.string.venue_category_university_college: StringResource by lazy {
      StringResource("string:venue_category_university_college", "venue_category_university_college", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10069, 97),
      ))
    }

@delegate:ResourceContentHash(-83_255_307)
internal val Res.string.venue_category_ux_ui_design: StringResource by lazy {
      StringResource("string:venue_category_ux_ui_design", "venue_category_ux_ui_design", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10167, 67),
      ))
    }

@delegate:ResourceContentHash(-715_750_879)
internal val Res.string.venue_category_vehicle_rental: StringResource by lazy {
      StringResource("string:venue_category_vehicle_rental", "venue_category_vehicle_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10235, 93),
      ))
    }

@delegate:ResourceContentHash(-168_975_334)
internal val Res.string.venue_category_vet_services: StringResource by lazy {
      StringResource("string:venue_category_vet_services", "venue_category_vet_services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10329, 63),
      ))
    }

@delegate:ResourceContentHash(3_528_478)
internal val Res.string.venue_category_veterinary_clinic: StringResource by lazy {
      StringResource("string:venue_category_veterinary_clinic", "venue_category_veterinary_clinic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10393, 92),
      ))
    }

@delegate:ResourceContentHash(-1_378_912_546)
internal val Res.string.venue_category_warehousing: StringResource by lazy {
      StringResource("string:venue_category_warehousing", "venue_category_warehousing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10486, 78),
      ))
    }

@delegate:ResourceContentHash(-130_110_834)
internal val Res.string.venue_category_waste_removal: StringResource by lazy {
      StringResource("string:venue_category_waste_removal", "venue_category_waste_removal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10565, 96),
      ))
    }

@delegate:ResourceContentHash(1_197_650_206)
internal val Res.string.venue_category_web_development: StringResource by lazy {
      StringResource("string:venue_category_web_development", "venue_category_web_development", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10662, 90),
      ))
    }

@delegate:ResourceContentHash(-972_772_769)
internal val Res.string.venue_category_windows_doors: StringResource by lazy {
      StringResource("string:venue_category_windows_doors", "venue_category_windows_doors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10753, 92),
      ))
    }

@delegate:ResourceContentHash(-624_430_713)
internal val Res.string.venue_cd_actions_menu: StringResource by lazy {
      StringResource("string:venue_cd_actions_menu", "venue_cd_actions_menu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10846, 49),
      ))
    }

@delegate:ResourceContentHash(1_535_707_896)
internal val Res.string.venue_day_fri: StringResource by lazy {
      StringResource("string:venue_day_fri", "venue_day_fri", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10896, 41),
      ))
    }

@delegate:ResourceContentHash(-839_292_329)
internal val Res.string.venue_day_mon: StringResource by lazy {
      StringResource("string:venue_day_mon", "venue_day_mon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10938, 45),
      ))
    }

@delegate:ResourceContentHash(-892_526_716)
internal val Res.string.venue_day_sat: StringResource by lazy {
      StringResource("string:venue_day_sat", "venue_day_sat", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10984, 37),
      ))
    }

@delegate:ResourceContentHash(-597_925_509)
internal val Res.string.venue_day_sun: StringResource by lazy {
      StringResource("string:venue_day_sun", "venue_day_sun", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11022, 37),
      ))
    }

@delegate:ResourceContentHash(-41_989_699)
internal val Res.string.venue_day_thu: StringResource by lazy {
      StringResource("string:venue_day_thu", "venue_day_thu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11060, 37),
      ))
    }

@delegate:ResourceContentHash(797_895_308)
internal val Res.string.venue_day_tue: StringResource by lazy {
      StringResource("string:venue_day_tue", "venue_day_tue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11098, 45),
      ))
    }

@delegate:ResourceContentHash(1_903_337_393)
internal val Res.string.venue_day_wed: StringResource by lazy {
      StringResource("string:venue_day_wed", "venue_day_wed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11144, 37),
      ))
    }

@delegate:ResourceContentHash(740_359_876)
internal val Res.string.venue_demo_address: StringResource by lazy {
      StringResource("string:venue_demo_address", "venue_demo_address", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11182, 110),
      ))
    }

@delegate:ResourceContentHash(865_113_400)
internal val Res.string.venue_demo_name: StringResource by lazy {
      StringResource("string:venue_demo_name", "venue_demo_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11293, 39),
      ))
    }

@delegate:ResourceContentHash(-227_218_726)
internal val Res.string.venue_demo_owner_email: StringResource by lazy {
      StringResource("string:venue_demo_owner_email", "venue_demo_owner_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11333, 50),
      ))
    }

@delegate:ResourceContentHash(2_125_539_842)
internal val Res.string.venue_demo_owner_first_name: StringResource by lazy {
      StringResource("string:venue_demo_owner_first_name", "venue_demo_owner_first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11384, 51),
      ))
    }

@delegate:ResourceContentHash(-2_083_774_096)
internal val Res.string.venue_demo_owner_last_name: StringResource by lazy {
      StringResource("string:venue_demo_owner_last_name", "venue_demo_owner_last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11436, 46),
      ))
    }

@delegate:ResourceContentHash(610_609_678)
internal val Res.string.venue_demo_owner_phone: StringResource by lazy {
      StringResource("string:venue_demo_owner_phone", "venue_demo_owner_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11483, 50),
      ))
    }

@delegate:ResourceContentHash(610_609_678)
internal val Res.string.venue_demo_phone: StringResource by lazy {
      StringResource("string:venue_demo_phone", "venue_demo_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11534, 44),
      ))
    }

@delegate:ResourceContentHash(2_645_954)
internal val Res.string.venue_demo_service_1_currency: StringResource by lazy {
      StringResource("string:venue_demo_service_1_currency", "venue_demo_service_1_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11579, 41),
      ))
    }

@delegate:ResourceContentHash(197_128_410)
internal val Res.string.venue_demo_service_1_description: StringResource by lazy {
      StringResource("string:venue_demo_service_1_description", "venue_demo_service_1_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11621, 204),
      ))
    }

@delegate:ResourceContentHash(400_385_045)
internal val Res.string.venue_demo_service_1_name: StringResource by lazy {
      StringResource("string:venue_demo_service_1_name", "venue_demo_service_1_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11826, 85),
      ))
    }

@delegate:ResourceContentHash(-1_866_015_479)
internal val Res.string.venue_demo_service_1_price: StringResource by lazy {
      StringResource("string:venue_demo_service_1_price", "venue_demo_service_1_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11912, 50),
      ))
    }

@delegate:ResourceContentHash(2_645_954)
internal val Res.string.venue_demo_service_2_currency: StringResource by lazy {
      StringResource("string:venue_demo_service_2_currency", "venue_demo_service_2_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11963, 41),
      ))
    }

@delegate:ResourceContentHash(905_596_949)
internal val Res.string.venue_demo_service_2_name: StringResource by lazy {
      StringResource("string:venue_demo_service_2_name", "venue_demo_service_2_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12005, 77),
      ))
    }

@delegate:ResourceContentHash(-1_866_015_479)
internal val Res.string.venue_demo_service_2_price: StringResource by lazy {
      StringResource("string:venue_demo_service_2_price", "venue_demo_service_2_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12083, 50),
      ))
    }

@delegate:ResourceContentHash(1_040_494_110)
internal val Res.string.venue_demo_website: StringResource by lazy {
      StringResource("string:venue_demo_website", "venue_demo_website", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12134, 46),
      ))
    }

@delegate:ResourceContentHash(-1_825_506_072)
internal val Res.string.venue_error_address_required: StringResource by lazy {
      StringResource("string:venue_error_address_required", "venue_error_address_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12181, 72),
      ))
    }

@delegate:ResourceContentHash(1_232_947_987)
internal val Res.string.venue_error_block_failed: StringResource by lazy {
      StringResource("string:venue_error_block_failed", "venue_error_block_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12254, 108),
      ))
    }

@delegate:ResourceContentHash(1_351_892_739)
internal val Res.string.venue_error_category_required: StringResource by lazy {
      StringResource("string:venue_error_category_required", "venue_error_category_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12363, 81),
      ))
    }

@delegate:ResourceContentHash(903_224_434)
internal val Res.string.venue_error_create_failed: StringResource by lazy {
      StringResource("string:venue_error_create_failed", "venue_error_create_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12445, 101),
      ))
    }

@delegate:ResourceContentHash(1_271_636_667)
internal val Res.string.venue_error_load_assignees_failed: StringResource by lazy {
      StringResource("string:venue_error_load_assignees_failed", "venue_error_load_assignees_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12547, 145),
      ))
    }

@delegate:ResourceContentHash(-1_891_585_403)
internal val Res.string.venue_error_load_failed: StringResource by lazy {
      StringResource("string:venue_error_load_failed", "venue_error_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12693, 119),
      ))
    }

@delegate:ResourceContentHash(-1_700_353_080)
internal val Res.string.venue_error_load_list_failed: StringResource by lazy {
      StringResource("string:venue_error_load_list_failed", "venue_error_load_list_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12813, 132),
      ))
    }

@delegate:ResourceContentHash(1_124_331_178)
internal val Res.string.venue_error_media_upload_failed: StringResource by lazy {
      StringResource("string:venue_error_media_upload_failed", "venue_error_media_upload_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12946, 107),
      ))
    }

@delegate:ResourceContentHash(1_242_696_055)
internal val Res.string.venue_error_name_required: StringResource by lazy {
      StringResource("string:venue_error_name_required", "venue_error_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13054, 89),
      ))
    }

@delegate:ResourceContentHash(2_061_448_613)
internal val Res.string.venue_error_pdf_only: StringResource by lazy {
      StringResource("string:venue_error_pdf_only", "venue_error_pdf_only", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13144, 88),
      ))
    }

@delegate:ResourceContentHash(153_090_217)
internal val Res.string.venue_error_phone_required: StringResource by lazy {
      StringResource("string:venue_error_phone_required", "venue_error_phone_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13233, 90),
      ))
    }

@delegate:ResourceContentHash(1_093_459_975)
internal val Res.string.venue_error_reassign_failed: StringResource by lazy {
      StringResource("string:venue_error_reassign_failed", "venue_error_reassign_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13324, 127),
      ))
    }

@delegate:ResourceContentHash(1_911_578_682)
internal val Res.string.venue_error_schedule_close_time_invalid: StringResource by lazy {
      StringResource("string:venue_error_schedule_close_time_invalid", "venue_error_schedule_close_time_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13452, 127),
      ))
    }

@delegate:ResourceContentHash(1_835_053_554)
internal val Res.string.venue_error_schedule_close_time_required: StringResource by lazy {
      StringResource("string:venue_error_schedule_close_time_required", "venue_error_schedule_close_time_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13580, 116),
      ))
    }

@delegate:ResourceContentHash(240_088_552)
internal val Res.string.venue_error_schedule_day_unknown: StringResource by lazy {
      StringResource("string:venue_error_schedule_day_unknown", "venue_error_schedule_day_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13697, 116),
      ))
    }

@delegate:ResourceContentHash(-245_586_297)
internal val Res.string.venue_error_schedule_open_time_invalid: StringResource by lazy {
      StringResource("string:venue_error_schedule_open_time_invalid", "venue_error_schedule_open_time_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13814, 126),
      ))
    }

@delegate:ResourceContentHash(929_962_086)
internal val Res.string.venue_error_schedule_open_time_required: StringResource by lazy {
      StringResource("string:venue_error_schedule_open_time_required", "venue_error_schedule_open_time_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13941, 119),
      ))
    }

@delegate:ResourceContentHash(-2_113_621_030)
internal val Res.string.venue_error_schedule_order_invalid: StringResource by lazy {
      StringResource("string:venue_error_schedule_order_invalid", "venue_error_schedule_order_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14061, 166),
      ))
    }

@delegate:ResourceContentHash(-1_986_970_809)
internal val Res.string.venue_error_service_currency_invalid: StringResource by lazy {
      StringResource("string:venue_error_service_currency_invalid", "venue_error_service_currency_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14228, 156),
      ))
    }

@delegate:ResourceContentHash(-380_576_024)
internal val Res.string.venue_error_service_name_required: StringResource by lazy {
      StringResource("string:venue_error_service_name_required", "venue_error_service_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14385, 97),
      ))
    }

@delegate:ResourceContentHash(1_837_176_168)
internal val Res.string.venue_error_service_price_invalid: StringResource by lazy {
      StringResource("string:venue_error_service_price_invalid", "venue_error_service_price_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14483, 117),
      ))
    }

@delegate:ResourceContentHash(1_255_510_671)
internal val Res.string.venue_error_update_failed: StringResource by lazy {
      StringResource("string:venue_error_update_failed", "venue_error_update_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14601, 97),
      ))
    }

@delegate:ResourceContentHash(1_365_101_664)
internal val Res.string.venue_error_upload_in_progress: StringResource by lazy {
      StringResource("string:venue_error_upload_in_progress", "venue_error_upload_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14699, 146),
      ))
    }

@delegate:ResourceContentHash(1_744_636_745)
internal val Res.string.venue_group_auto: StringResource by lazy {
      StringResource("string:venue_group_auto", "venue_group_auto", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14846, 36),
      ))
    }

@delegate:ResourceContentHash(-1_404_032_480)
internal val Res.string.venue_group_beauty: StringResource by lazy {
      StringResource("string:venue_group_beauty", "venue_group_beauty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14883, 66),
      ))
    }

@delegate:ResourceContentHash(-1_913_255_598)
internal val Res.string.venue_group_business: StringResource by lazy {
      StringResource("string:venue_group_business", "venue_group_business", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14950, 112),
      ))
    }

@delegate:ResourceContentHash(-1_130_742_008)
internal val Res.string.venue_group_education: StringResource by lazy {
      StringResource("string:venue_group_education", "venue_group_education", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15063, 77),
      ))
    }

@delegate:ResourceContentHash(1_274_836_302)
internal val Res.string.venue_group_entertainment: StringResource by lazy {
      StringResource("string:venue_group_entertainment", "venue_group_entertainment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15141, 81),
      ))
    }

@delegate:ResourceContentHash(1_476_817_762)
internal val Res.string.venue_group_events: StringResource by lazy {
      StringResource("string:venue_group_events", "venue_group_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15223, 62),
      ))
    }

@delegate:ResourceContentHash(-1_867_152_938)
internal val Res.string.venue_group_food: StringResource by lazy {
      StringResource("string:venue_group_food", "venue_group_food", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15286, 72),
      ))
    }

@delegate:ResourceContentHash(1_148_396_627)
internal val Res.string.venue_group_health: StringResource by lazy {
      StringResource("string:venue_group_health", "venue_group_health", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15359, 78),
      ))
    }

@delegate:ResourceContentHash(1_128_306_451)
internal val Res.string.venue_group_home: StringResource by lazy {
      StringResource("string:venue_group_home", "venue_group_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15438, 112),
      ))
    }

@delegate:ResourceContentHash(336_578_466)
internal val Res.string.venue_group_household: StringResource by lazy {
      StringResource("string:venue_group_household", "venue_group_household", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15551, 73),
      ))
    }

@delegate:ResourceContentHash(1_714_215_639)
internal val Res.string.venue_group_it_media: StringResource by lazy {
      StringResource("string:venue_group_it_media", "venue_group_it_media", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15625, 80),
      ))
    }

@delegate:ResourceContentHash(846_177_088)
internal val Res.string.venue_group_logistics: StringResource by lazy {
      StringResource("string:venue_group_logistics", "venue_group_logistics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15706, 81),
      ))
    }

@delegate:ResourceContentHash(-111_085_589)
internal val Res.string.venue_group_pets: StringResource by lazy {
      StringResource("string:venue_group_pets", "venue_group_pets", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15788, 68),
      ))
    }

@delegate:ResourceContentHash(719_782_378)
internal val Res.string.venue_group_shopping: StringResource by lazy {
      StringResource("string:venue_group_shopping", "venue_group_shopping", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15857, 76),
      ))
    }

@delegate:ResourceContentHash(-66_497_695)
internal val Res.string.venue_group_travel: StringResource by lazy {
      StringResource("string:venue_group_travel", "venue_group_travel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15934, 82),
      ))
    }

@delegate:ResourceContentHash(1_890_275_889)
internal val Res.string.venue_list_add_button: StringResource by lazy {
      StringResource("string:venue_list_add_button", "venue_list_add_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16017, 65),
      ))
    }

@delegate:ResourceContentHash(-1_449_448_529)
internal val Res.string.venue_list_empty_description: StringResource by lazy {
      StringResource("string:venue_list_empty_description", "venue_list_empty_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16083, 160),
      ))
    }

@delegate:ResourceContentHash(-755_806_346)
internal val Res.string.venue_list_empty_title: StringResource by lazy {
      StringResource("string:venue_list_empty_title", "venue_list_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16244, 74),
      ))
    }

@delegate:ResourceContentHash(1_522_781_474)
internal val Res.string.venue_list_filter_status: StringResource by lazy {
      StringResource("string:venue_list_filter_status", "venue_list_filter_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16319, 48),
      ))
    }

@delegate:ResourceContentHash(-1_788_186_435)
internal val Res.string.venue_list_search_placeholder: StringResource by lazy {
      StringResource("string:venue_list_search_placeholder", "venue_list_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16368, 73),
      ))
    }

@delegate:ResourceContentHash(-998_165_598)
internal val Res.string.venue_location_address_label: StringResource by lazy {
      StringResource("string:venue_location_address_label", "venue_location_address_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16442, 52),
      ))
    }

@delegate:ResourceContentHash(487_945_778)
internal val Res.string.venue_location_address_placeholder: StringResource by lazy {
      StringResource("string:venue_location_address_placeholder", "venue_location_address_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16495, 78),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("venue_category_production_photo_video", Res.string.venue_category_production_photo_video)
  map.put("venue_category_psychotherapy", Res.string.venue_category_psychotherapy)
  map.put("venue_category_quest_vr", Res.string.venue_category_quest_vr)
  map.put("venue_category_real_estate_agency", Res.string.venue_category_real_estate_agency)
  map.put("venue_category_renovation_design", Res.string.venue_category_renovation_design)
  map.put("venue_category_restaurant", Res.string.venue_category_restaurant)
  map.put("venue_category_search_placeholder", Res.string.venue_category_search_placeholder)
  map.put("venue_category_shoe_clothes_repair", Res.string.venue_category_shoe_clothes_repair)
  map.put("venue_category_solarium", Res.string.venue_category_solarium)
  map.put("venue_category_spa_massage", Res.string.venue_category_spa_massage)
  map.put("venue_category_steak_house", Res.string.venue_category_steak_house)
  map.put("venue_category_sushi_asian", Res.string.venue_category_sushi_asian)
  map.put("venue_category_tattoo_piercing", Res.string.venue_category_tattoo_piercing)
  map.put("venue_category_tax_consulting", Res.string.venue_category_tax_consulting)
  map.put("venue_category_taxi_rental", Res.string.venue_category_taxi_rental)
  map.put("venue_category_tech_repair", Res.string.venue_category_tech_repair)
  map.put("venue_category_tire_service", Res.string.venue_category_tire_service)
  map.put("venue_category_tourism_hotels", Res.string.venue_category_tourism_hotels)
  map.put("venue_category_training_center", Res.string.venue_category_training_center)
  map.put("venue_category_transfer_taxi", Res.string.venue_category_transfer_taxi)
  map.put("venue_category_travel_agency", Res.string.venue_category_travel_agency)
  map.put("venue_category_tuning_detailing", Res.string.venue_category_tuning_detailing)
  map.put("venue_category_tutoring", Res.string.venue_category_tutoring)
  map.put("venue_category_university_college", Res.string.venue_category_university_college)
  map.put("venue_category_ux_ui_design", Res.string.venue_category_ux_ui_design)
  map.put("venue_category_vehicle_rental", Res.string.venue_category_vehicle_rental)
  map.put("venue_category_vet_services", Res.string.venue_category_vet_services)
  map.put("venue_category_veterinary_clinic", Res.string.venue_category_veterinary_clinic)
  map.put("venue_category_warehousing", Res.string.venue_category_warehousing)
  map.put("venue_category_waste_removal", Res.string.venue_category_waste_removal)
  map.put("venue_category_web_development", Res.string.venue_category_web_development)
  map.put("venue_category_windows_doors", Res.string.venue_category_windows_doors)
  map.put("venue_cd_actions_menu", Res.string.venue_cd_actions_menu)
  map.put("venue_day_fri", Res.string.venue_day_fri)
  map.put("venue_day_mon", Res.string.venue_day_mon)
  map.put("venue_day_sat", Res.string.venue_day_sat)
  map.put("venue_day_sun", Res.string.venue_day_sun)
  map.put("venue_day_thu", Res.string.venue_day_thu)
  map.put("venue_day_tue", Res.string.venue_day_tue)
  map.put("venue_day_wed", Res.string.venue_day_wed)
  map.put("venue_demo_address", Res.string.venue_demo_address)
  map.put("venue_demo_name", Res.string.venue_demo_name)
  map.put("venue_demo_owner_email", Res.string.venue_demo_owner_email)
  map.put("venue_demo_owner_first_name", Res.string.venue_demo_owner_first_name)
  map.put("venue_demo_owner_last_name", Res.string.venue_demo_owner_last_name)
  map.put("venue_demo_owner_phone", Res.string.venue_demo_owner_phone)
  map.put("venue_demo_phone", Res.string.venue_demo_phone)
  map.put("venue_demo_service_1_currency", Res.string.venue_demo_service_1_currency)
  map.put("venue_demo_service_1_description", Res.string.venue_demo_service_1_description)
  map.put("venue_demo_service_1_name", Res.string.venue_demo_service_1_name)
  map.put("venue_demo_service_1_price", Res.string.venue_demo_service_1_price)
  map.put("venue_demo_service_2_currency", Res.string.venue_demo_service_2_currency)
  map.put("venue_demo_service_2_name", Res.string.venue_demo_service_2_name)
  map.put("venue_demo_service_2_price", Res.string.venue_demo_service_2_price)
  map.put("venue_demo_website", Res.string.venue_demo_website)
  map.put("venue_error_address_required", Res.string.venue_error_address_required)
  map.put("venue_error_block_failed", Res.string.venue_error_block_failed)
  map.put("venue_error_category_required", Res.string.venue_error_category_required)
  map.put("venue_error_create_failed", Res.string.venue_error_create_failed)
  map.put("venue_error_load_assignees_failed", Res.string.venue_error_load_assignees_failed)
  map.put("venue_error_load_failed", Res.string.venue_error_load_failed)
  map.put("venue_error_load_list_failed", Res.string.venue_error_load_list_failed)
  map.put("venue_error_media_upload_failed", Res.string.venue_error_media_upload_failed)
  map.put("venue_error_name_required", Res.string.venue_error_name_required)
  map.put("venue_error_pdf_only", Res.string.venue_error_pdf_only)
  map.put("venue_error_phone_required", Res.string.venue_error_phone_required)
  map.put("venue_error_reassign_failed", Res.string.venue_error_reassign_failed)
  map.put("venue_error_schedule_close_time_invalid", Res.string.venue_error_schedule_close_time_invalid)
  map.put("venue_error_schedule_close_time_required", Res.string.venue_error_schedule_close_time_required)
  map.put("venue_error_schedule_day_unknown", Res.string.venue_error_schedule_day_unknown)
  map.put("venue_error_schedule_open_time_invalid", Res.string.venue_error_schedule_open_time_invalid)
  map.put("venue_error_schedule_open_time_required", Res.string.venue_error_schedule_open_time_required)
  map.put("venue_error_schedule_order_invalid", Res.string.venue_error_schedule_order_invalid)
  map.put("venue_error_service_currency_invalid", Res.string.venue_error_service_currency_invalid)
  map.put("venue_error_service_name_required", Res.string.venue_error_service_name_required)
  map.put("venue_error_service_price_invalid", Res.string.venue_error_service_price_invalid)
  map.put("venue_error_update_failed", Res.string.venue_error_update_failed)
  map.put("venue_error_upload_in_progress", Res.string.venue_error_upload_in_progress)
  map.put("venue_group_auto", Res.string.venue_group_auto)
  map.put("venue_group_beauty", Res.string.venue_group_beauty)
  map.put("venue_group_business", Res.string.venue_group_business)
  map.put("venue_group_education", Res.string.venue_group_education)
  map.put("venue_group_entertainment", Res.string.venue_group_entertainment)
  map.put("venue_group_events", Res.string.venue_group_events)
  map.put("venue_group_food", Res.string.venue_group_food)
  map.put("venue_group_health", Res.string.venue_group_health)
  map.put("venue_group_home", Res.string.venue_group_home)
  map.put("venue_group_household", Res.string.venue_group_household)
  map.put("venue_group_it_media", Res.string.venue_group_it_media)
  map.put("venue_group_logistics", Res.string.venue_group_logistics)
  map.put("venue_group_pets", Res.string.venue_group_pets)
  map.put("venue_group_shopping", Res.string.venue_group_shopping)
  map.put("venue_group_travel", Res.string.venue_group_travel)
  map.put("venue_list_add_button", Res.string.venue_list_add_button)
  map.put("venue_list_empty_description", Res.string.venue_list_empty_description)
  map.put("venue_list_empty_title", Res.string.venue_list_empty_title)
  map.put("venue_list_filter_status", Res.string.venue_list_filter_status)
  map.put("venue_list_search_placeholder", Res.string.venue_list_search_placeholder)
  map.put("venue_location_address_label", Res.string.venue_location_address_label)
  map.put("venue_location_address_placeholder", Res.string.venue_location_address_placeholder)
}
